import { useCallback } from 'react'
import { ReactTablePaged } from 'uikit/ReactTable'
import {
  Container,
  FilterStack,
  SnippetsContainer,
  SnippetsContainerMain,
  SnippetsContainerRightAside,
} from 'uikit/layout'
import { ItemBySovcomClientId, columns } from './List.config'
import { FilterState, ListFilter } from './ListFilter'
import { useFetchUserListBySovcomClientId } from './hooks/useFetchUserListBySovcomClientId'

export const List = () => {
  const { mutate, data, isPending } = useFetchUserListBySovcomClientId()

  const onChangeFilters = useCallback(
    (state: FilterState) => {
      const { clientId } = state
      mutate({ clientId: clientId || '' })
    },
    [mutate]
  )

  return (
    <Container>
      <SnippetsContainer indentTop={122}>
        <SnippetsContainerMain>
          <ReactTablePaged<ItemBySovcomClientId>
            storageId="UserListBySovcomClientId"
            isLoading={isPending}
            columns={columns}
            data={data || []}
          />
        </SnippetsContainerMain>
        <SnippetsContainerRightAside>
          <FilterStack>
            <ListFilter onChange={onChangeFilters} />
          </FilterStack>
        </SnippetsContainerRightAside>
      </SnippetsContainer>
    </Container>
  )
}
